import { IClassname } from '@/lib/shared/model/classname';

export const SmokeSensor = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.41557 1.3042C6.24713 1.30747 6.0865 1.37584 5.96738 1.49497C5.84825 1.61409 5.77988 1.77472 5.77661 1.94316V3.22107C5.78103 3.65808 5.86325 4.09081 6.01942 4.49899L8.08964 9.61066C8.17217 9.77735 8.29708 9.91942 8.45185 10.0226C8.60661 10.1258 8.78579 10.1864 8.9714 10.1985H23.0285C23.2141 10.1864 23.3933 10.1258 23.548 10.0226C23.7028 9.91942 23.8277 9.77735 23.9102 9.61066L25.9805 4.49899C26.1366 4.09081 26.2189 3.65808 26.2233 3.22107V1.94316C26.22 1.77472 26.1516 1.61409 26.0325 1.49497C25.9134 1.37584 25.7528 1.30747 25.5843 1.3042H6.41557Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.79883 6.41602H25.2008"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 6.41602V10.2498"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4727 6.41602L19.8337 10.2498"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5273 6.41602L12.1663 10.2498"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.3895 10.2495C22.3895 12.013 19.8337 14.0833 15.9999 14.0833C12.1662 14.0833 9.61035 12.013 9.61035 10.2495"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4282 17.917C4.67756 23.9488 15.5399 24.6644 9.82756 30.6962"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.3067 17.917C10.5561 23.9488 21.4184 24.6644 15.6933 30.6962"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.1723 17.917C16.4344 23.9488 27.284 24.6644 21.5717 30.6962"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
